export const obterDataAtual = (data) => {
    // yyyy-MM-dd
    return data.toISOString().split("T")[0];
  };
  
export  const obterHoraAtual = (data) => {
    // hh:mm:ss
    return data.toTimeString().split(" ")[0];
  };
  
export  const obterDataFormatadaParaLinhaP = (data) => {
    // Formato dd-MM-yyyy
    return data
      .toLocaleDateString("pt-BR")
      .split("/")
      .reverse()
      .join("-")
      .replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3-$2-$1");
  };
  
export const obterHoraCompleta = (data) => {
    const hora = data.getHours().toString().padStart(2, "0");
    const minuto = data.getMinutes().toString().padStart(2, "0");
    const segundo = data.getSeconds().toString().padStart(2, "0");
    return `${hora}:${minuto}:${segundo}`;
  };
  